export default "__VITE_ASSET__DsmB9o_1__"